import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { ASSETS_DIRECT_URL, ASSETS_URL, CDN_FALLBACK_URL, CDN_URL } from '../app.constants';
import { KeyMap } from './climate-engine/ccc-algorithm/key-map';

@Injectable({
  providedIn: 'root',
})
export class FallbackInterceptorService implements HttpInterceptor {
  private _fallBackMap: KeyMap<string> = {};

  constructor() {
    this._setupFallBackMap();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        const regex = /https:\/\/[^\/]*\//g;
        const domainMatch = regex.exec(req.url);
        if (domainMatch && this._fallBackMap[domainMatch[0]] !== undefined) {
          const fallbackReq = req.clone({
            url: req.url.replace(domainMatch[0], this._fallBackMap[domainMatch[0]]),
          });
          return next.handle(fallbackReq);
        } else {
          return throwError(() => error);
        }
      })
    );
  }

  private _setupFallBackMap(): void {
    this._fallBackMap[ASSETS_URL] = ASSETS_DIRECT_URL;
    this._fallBackMap[CDN_URL] = CDN_FALLBACK_URL;
  }
}
